exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-button--disabled-hover.is-disabled:hover {\n  background-color: #c0c0c0 !important;\n  cursor: not-allowed;\n}\n", ""]);

// exports
